import React, { useState, useRef, useEffect } from "react";
import helpCircle from '../Assets/Icons/Help circle.png'

const TooltipPopup = ({ text }) => {
    const [isVisible, setIsVisible] = useState(false);
    const tooltipRef = useRef(null);

    const toggleTooltip = (event) => {
        event.stopPropagation(); // Prevent immediate closing
        setIsVisible(!isVisible);
    };

    // Close tooltip when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                setIsVisible(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

       // Split the text using '. ' as the separator
       const splitText = text.split('.');
       console.log('text',text,'splitText:',splitText)
    return (
        <div style={styles.container} ref={tooltipRef}>
           
            <img
                src={helpCircle}
                style={{ cursor: "pointer", width: "11px", height: "11px" }}
                alt="Help"
                onClick={toggleTooltip}
            />

            {isVisible && (
               <div style={styles.tooltip}>
              {/* <div style={styles.textStyle}> {text} </div> */}
                      {/* Display each part of the text in separate divs */}
                      <div style={styles.textStyle}>
                      {splitText.map((part, index) => {
                        return (
                            <div key={index} >
                                {part.trim()}.
                            </div>
                        );
                    })}</div>
               <div style={styles.tooltipArrow}></div>
             </div>
            )}
        </div>
    );
};

const styles = {
    container: {
      position: "relative",
      display: "inline-block",
      height:'11px'
    },
    icon: {
      cursor: "pointer",
      fontSize: "18px",
      marginLeft: "5px",
    },
    textStyle:{
        fontSize: "14px",
        fontWeight: "500",
        color: "#333",
        backgroundColor:'#FFFFFF',
        padding:"10px",
        whiteSpace:'pre',
        // maxWidth:'500px',
        // overflowX:'scroll'
    },
    tooltip: {
        position: "absolute",
        top: "-65px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#EDE7F6", // Light gray background (as in image)
       
        padding: "10px 15px",
        borderRadius: "8px",
        
        // boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 10,
        whiteSpace: "nowrap",
        transition: "opacity 0.3s ease-in-out",
        // maxWidth:'500px',
      },
      tooltipArrow: {
        content: '""',
        position: "absolute",
        top: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        borderWidth: "8px",
        borderStyle: "solid",
        borderColor: "#EDE7F6 transparent transparent transparent", // Arrow color same as tooltip
      },
  };

export default TooltipPopup;
